import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface AssignConflictDialogProps {
    open: boolean;
    existingOwnerName: string | null;
    onConfirm: () => void;
    onCancel: () => void;
    isLoading?: boolean;
}

// דיאלוג אישור דריסת שיוך קיים — מוצג כאשר הצ'יפ כבר משויך למשתמש אחר.
export function AssignConflictDialog({open, existingOwnerName, onConfirm, onCancel, isLoading}: AssignConflictDialogProps) {
    return (
        <AlertDialog open={open} onOpenChange={(value) => { if (!value) onCancel(); }}>
            <AlertDialogContent dir="rtl">
                <AlertDialogHeader className="text-right sm:text-right">
                    <AlertDialogTitle>הכרטיס כבר משויך למשתמש אחר</AlertDialogTitle>
                    <AlertDialogDescription className="text-base">
                        הכרטיס משויך כרגע ל-<strong>{existingOwnerName || 'משתמש לא ידוע'}</strong>.
                        האם לבטל את השיוך הקיים ולשייך את הכרטיס למשתמש החדש?
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter className="sm:justify-start sm:flex-row-reverse">
                    <AlertDialogCancel disabled={isLoading}>ביטול</AlertDialogCancel>
                    <AlertDialogAction onClick={onConfirm} disabled={isLoading}>
                        {isLoading ? "משייך..." : "כן, דרוס שיוך קיים"}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
